<template>
  <v-form class="mx-10 mb-10 pa-10 text-center">
    <h3 class="text-left mb-5 text-primary">Add certificate (<span v-html="serverConfig?.credential?.id"></span>)</h3>
    <v-layout>
      <v-flex md4>
        <v-textarea
          background-color="rgba(255,255,255)"
          v-model="localcsr"
          outlined
          no-resize
          height="240"
          label="CSR">
        </v-textarea>
      </v-flex>
      <v-flex md2>
        <v-btn
          color="#007CA4"
          @click="generateCSR"
          class="mb-8"
          dark>
          Generate CSR
        </v-btn>
        <v-btn
          class="mt-8"
          :disabled="localpkcs7 == ''"
          color="#007CA4"
          @click="installCertificate"
          dark>
          Install Certificate >>
        </v-btn>
      </v-flex>
      <v-flex md6>
        <v-textarea
          background-color="rgba(255,255,255)"
          v-model="localpkcs7"
          outlined
          no-resize
          height="240"
          label="pkcs7">
        </v-textarea>
      </v-flex>
    </v-layout>
  </v-form>
</template>
<script>
import { mapMutations } from 'vuex';
import alisonServer from  '../services/alisonServer.js';
  export default {
    props:["data", "config", "serverConfig", "pkcs7"],
    data: () => ({
      localcsr: '',
      localpkcs7: '',
    }),
    mounted(){
      this.localcsr = this.csr;
      if (this.pkcs7 == null)
        return
      let concat = "-----BEGIN PKCS7-----\n";
      for (let i = 0; i < this.pkcs7.length; i++) {
        concat += this.pkcs7.charCodeAt(i) === 10 ? "\n" : this.pkcs7.charAt(i)
      }
      concat += "\n-----END PKCS7-----";
      this.localpkcs7 = concat;
    },
    watch:{
      pkcs7(newValue) {
        this.localpkcs7 = newValue;
      },
      csr(newValue) {
        this.localcsr = newValue;
      }
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      
      async generateCSR() {
        try {
          let { csr } = await alisonServer.generateCSR(this.serverConfig.seatId, this.serverConfig.credential.id);
          csr = `-----BEGIN CERTIFICATE REQUEST-----\n${csr}-----END CERTIFICATE REQUEST-----`;
          this.localcsr = csr;
          this.$emit("setCSR", csr);
        } catch (e) {
          console.log(e);
          this.setColor("error");
          this.setSnack(e);
        }
        
      },

      async installCertificate() {
        try {
          await alisonServer.installCertificate(this.localpkcs7, this.serverConfig.seatId, this.serverConfig.credential.id);
          this.setColor("success");
          this.setSnack("Certificate added to credential " + this.serverConfig.credential.id);
        } catch (e) {
          console.log(e);
          this.setColor("error");
          this.setSnack(e);
        }
      }
    },
  }
</script>